<!--
* @Name：报价信息对比
* @Author: 王超
* @Date: 2025-09-17 10:39:49
* @Last Modified by: 王超
* @Last Modified time: 2025-09-17 10:39:49
-->
<template>
  <div>
    <hi-card>
      <van-row>
        <span>币种：</span>
        <span>{{ mainInfo.currencyName }}</span>
      </van-row>
      <van-row>
        <span>是否含税：</span>
        <span>{{ mainInfo.taxHaveNot | dictFilter(taxHaveNotDictOptions) }}</span>
      </van-row>
      <van-row>
        <span>阶梯报价：</span>
        <span>{{ mainInfo.tieredPrice | dictFilter(tieredPriceDictOptions) }}</span>
      </van-row>
      <van-row>
        <span>模具费摊销：</span>
        <span>{{ mainInfo.modleAmortize }}</span>
      </van-row>
      <van-row>
        <span>交期：</span>
        <span>{{ mainInfo.deliveryTime }}</span>
      </van-row>
    </hi-card>
    <hi-card v-for="(item, index) in priceCompSupp.subjectList" :key="item.poCreateItemId" :row-index="index + 1">
      <van-row>
        <span>标的行项目编码：</span>
        <span>{{ item.subjectNo }}</span>
      </van-row>
      <van-row>
        <span>物料编码：</span>
        <span>{{ item.materialId }}</span>
      </van-row>
      <van-row>
        <span>物料描述：</span>
        <span>{{ item.materialDesc }}</span>
      </van-row>
      <van-row>
        <span>物料信息补充：</span>
        <span>{{ item.materialExt }}</span>
      </van-row>
      <van-row>
        <span>基本单位：</span>
        <span>{{ item.unit }}</span>
      </van-row>
      <van-row>
        <span>基本单位说明：</span>
        <span>{{ item.unitInfo }}</span>
      </van-row>
      <van-row>
        <span>数量：</span>
        <span>{{ item.quantity }}</span>
      </van-row>
      <van-row>
        <van-button type="info" size="normal" style="margin-bottom: 5px" @click="clickItem(item)"
          >查看报价信息</van-button
        >
      </van-row>
    </hi-card>
    <enquiry-detail-info
      v-if="detailsVisible"
      :details-visible="detailsVisible"
      :rank-info-list="detailsItem"
      :show-step-price="showStepPrice"
      @close-details-dialog="detailsVisible = false"
    />
  </div>
</template>

<script>
export default {
  name: 'MaterialDetails',
  components: {
    'enquiry-detail-info': () => import('./EnquiryDetailInfo')
  },
  data() {
    return {
      detailsVisible: false,
      priceDialogVisible: false,
      detailsItem: []
    }
  },
  props: {
    priceCompSupp: {
      type: Object,
      required: true
    },
    mainInfo: {
      type: Object,
      required: true
    }
  },
  computed: {
    showStepPrice() {
      return this.mainInfo && this.mainInfo.tieredPrice !== '0'
    },
    taxHaveNotDictOptions() {
      return this.$store.getters.dicts.yes_no
    },
    tieredPriceDictOptions() {
      return this.$store.getters.dicts.tiered_price
    }
  },
  methods: {
    clickItem(item) {
      this.detailsItem = item.rankInfoList
      this.detailsVisible = true
    }
  }
}
</script>
